<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="sz">Eon</span></h1>
<p class="author"><span class="sz">Greg Bear</span></p>
<p class="colophon"><img alt="Open Road logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section1.vue?38b7d9c2